import { Coordinates, CoordinatesResponse } from '../../../@types/geographicInformationSystem-types'

export const coordinatesToApp = (data: CoordinatesResponse): Coordinates => ({
  latitude: data.wgs84Coordinate.latitude,
  longitude: data.wgs84Coordinate.longitude,
  lambertEuCoordinatesX: data.lambertEuCoordinate.x,
  lambertEuCoordinatesY: data.lambertEuCoordinate.y,
})
